

































































import { Component, Vue } from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import ChannelDialog from './ChannelDialog.vue'
import StatusEffective from '@/components/common/StatusEffective.vue'

import $Api from '@api'
import { finalize } from 'rxjs/operators'
import { UtilsIndex } from '@/utils'
import { statusMap } from '@/utils/status-map'

@Component({
    components: {
        SearchForm,
        TableForm,
        StatusEffective,
        ChannelDialog
    }
})
export default class extends Vue {
    formEl: any
    searchForm = {
        current: 1,
        size: 10,
        id: null,
        channelName: null,
        status: null
    }
    statusMap = statusMap
    statusOptions = statusMap.createArray()
    channelOptions = []

    tableLoading = false
    tableData = []
    total = 0

    formProp = {}
    show = false
    disabled = false

    dateFormatter(row: any, column: any, cellValue: any, index: any) {
        return cellValue
            ? UtilsIndex.formatDate(cellValue, 'yyyy-MM-dd hh:mm:ss')
            : ''
    }

    onSearchSubmit() {
        this.searchForm.current = 1
        this.getData()
    }

    getData(pageQuery = {}) {
        this.tableLoading = true
        $Api.channelService
            .channelList(Object.assign(this.searchForm, pageQuery))
            .pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(data => {
                this.tableData = data.list
                this.total = data.total
            })
    }

    // 新建
    create() {
        this.formProp = {}
        this.show = true
        this.disabled = false
    }

    // 编辑
    modify(row: any) {
        this.formProp = { ...row }
        this.show = true
        this.disabled = false
    }

    created() {
        this.getData()
    }
}
